import { useSelector } from "react-redux";
import { SmsReportQuery } from "../../../hooks/apis/reports.api";
import { RootState } from "../../../store/store";
import { Button, Flex, Select, TimePicker } from "antd";
import { formatPhoneNumber } from "../../../utils/phoneLib";
import dayjs from "dayjs";

export const ReportFilters: React.FC<{
    filters: SmsReportQuery;
    loading: boolean;
    setFilters: React.Dispatch<React.SetStateAction<SmsReportQuery>>;
    applyFilters: () => void;
    type: "messages" | "bulk_messages";
}> = ({ filters, setFilters, applyFilters, loading , type}) => {

    const { data: dids } = useSelector((state: RootState) => state.smsDids);
    const users = useSelector((state: RootState) => state.didUsers);

    
    return (
        <Flex gap={6} wrap="wrap" align="center" style={{padding: '20px'}}>
            <Select
                maxTagCount={"responsive"}
                maxTagTextLength={10}
                className="report-select-filter"
                optionRender={(option) => {
                    const did = dids.find(d => d.did === option.value);
                    return (
                        <div style={{ display: 'flex', flexDirection: 'column', padding: '2px 0' }}>
                            <span style={{ fontWeight: '500', fontSize: '14px' }}>{formatPhoneNumber(option.value as string)}</span>
                            {did?.label && (
                                <span style={{ color: '#999', fontSize: '12px', marginTop: '2px' }}>
                                    {did.label}
                                </span>
                            )}
                        </div>
                    );
                }}
                options={[
                    ...dids.map(did => {
                        return {
                            label: formatPhoneNumber(did.did),
                            value: did.did
                        };
                    })
                ]}
                onClear={() => {
                    setFilters(prev => ({
                        ...prev,
                        dids: []
                    }));
                }}
                allowClear
                mode="multiple"
                onChange={value => {
                    setFilters(prev => ({
                        ...prev,
                        dids: value
                    }));
                }}
                filterOption={(input, option) => {
                    const did = dids.find(d => d.did === option?.value);
                    const number = formatPhoneNumber(option?.value as string);
                    const label = did?.label || "";
                
                    return (
                      number?.toLowerCase().includes(input.toLowerCase()) ||
                      label.toLowerCase().includes(input.toLowerCase())
                    );
                  }}
                value={filters.dids}
                style={{ minWidth: "200px", maxWidth: "200px" }}
                placeholder="Number"
            />
            <Select
                className="report-select-filter"
                placeholder="User"
                showSearch
                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                style={{ minWidth: "200px", maxWidth: "200px" }}
                options={[
                    ...users.map(user => {
                        return {
                            label: `${user.first_name} ${user.last_name}`,
                            value: user.id
                        };
                    })
                ]}
                onClear={() => {
                    setFilters(prev => ({
                        ...prev,
                        user: ""
                    }));
                }}
                allowClear
                onChange={value => {
                    setFilters(prev => ({
                        ...prev,
                        user: value
                    }));
                }}
                value={filters.user}
            />
            {type === "messages" && 
            <Select
                className="report-select-filter"
                placeholder="Direction"
                style={{ minWidth: "200px", maxWidth: "200px" }}
                onClear={() => {
                    setFilters(prev => ({
                        ...prev,
                        direction: ""
                    }));
                }}
                value={filters.direction}
                allowClear
                onChange={value => {
                    setFilters(prev => ({
                        ...prev,
                        direction: value
                    }));
                }}
                options={[
                    {
                        label: "Incoming",
                        value: "inbound"
                    },
                    {
                        label: "Outgoing",
                        value: "outbound"
                    }
                ]}
            />
            }
            <Select
                className="report-select-filter"
                placeholder="Status"
                style={{ minWidth: "200px", maxWidth: "200px" }}
                mode="multiple"
                onClear={() => {
                    setFilters(prev => ({
                        ...prev,
                        status: null
                    }));
                }}
                value={filters.status}
                allowClear
                onChange={value => {
                    setFilters(prev => ({
                        ...prev,
                        status: value
                    }));
                }}
                maxTagCount={"responsive"}
                maxTagTextLength={12}
                options={[
                    {
                        label: "Sent",
                        value: "sent"
                    },
                    {
                        label: "Received",
                        value: "received"
                    },
                    {
                        label: "Failed",
                        value: "failed"
                    }
                ]}
            />
            <TimePicker.RangePicker
                style={{ background: "#EFEDFF" }}
                format={"hh:mm A"}
                value={filters.start_time && filters.end_time ? [dayjs(filters.start_time), dayjs(filters.end_time)] : null}
                onChange={val => {
                    if (val && val[0] && val[1]) {
                        const startDateTime = dayjs(filters.start_date).hour(val[0].hour()).minute(val[0].minute()).second(0);
                        const endDateTime = dayjs(filters.end_date).hour(val[1].hour()).minute(val[1].minute()).second(0);

                        setFilters(prev => ({
                            ...prev,
                            start_time: startDateTime.toDate(),
                            end_time: endDateTime.toDate()
                        }));
                    } else {
                        setFilters(prev => ({
                            ...prev,
                            start_time: null,
                            end_time: null
                        }));
                    }
                }}
                placeholder={["Start Time", "End Time"]}
                allowClear
            />
            <Button loading={loading} onClick={applyFilters} type="primary">
                Apply
            </Button>
        </Flex>
    );
};
